import { Device, Store } from '@/classes';
import { parse, stringify } from 'qs';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export const useRouter = () => {
  const navigate = useNavigate();

  const refresh = useCallback(() => {
    navigate(0);
  }, [navigate]);

  const push = useCallback(
    (path: string, options?: { replace?: boolean; focusKey?: string }) => {
      const pathname = window.location.pathname.replace(process.env.NODE_ENV === 'development' ? '/smart-tv' : '', '');
      const query = parse(window.location.search, { ignoreQueryPrefix: true });

      let histories = Store.get('histories');

      if (options?.focusKey) {
        query.f = options.focusKey;
      }

      if (!histories) {
        histories = [];
        Store.set('histories', histories);
      }

      if (!options?.replace || !histories.length) {
        histories.push({ pathname, query });
      }

      navigate(path);
    },
    [navigate],
  );

  const pop = useCallback(() => {
    const pathname = window.location.pathname.replace(process.env.NODE_ENV === 'development' ? '/smart-tv' : '', '');
    const histories = Store.get('histories');
    const MAIN_PAGES = ['/nursery-rhymes', '/fairy-tales', '/movies', '/topics', '/profile'];
    const CLOSE_PAGES = ['', '/', '/home', '/splash', '/login'];

    if (CLOSE_PAGES.includes(pathname)) {
      Device.close();
      return;
    }

    if (MAIN_PAGES.includes(pathname)) {
      Store.set('histories', []);
      navigate('/home');
    } else {
      if (histories && histories.length > 0) {
        const history = histories.pop();

        if (history.query) {
          navigate(`${history.pathname}?${stringify(history.query)}`);
        } else {
          navigate(`${history.pathname}`);
        }
      } else if (!CLOSE_PAGES.includes(pathname)) {
        navigate('/home');
      } else {
        Device.close();
      }
    }
  }, [navigate]);

  const value = useMemo(() => ({ push, pop, refresh }), [push, pop, refresh]);

  return value;
};
